
import {mapActions} from "vuex";

export default {
  name: "DialogStartupMemberInvitation",
  props: {
    visible: Boolean,
    detail: Object,
    stakeholderId: [String, Number],
    invitedMembers: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      requestingInvitation: false,
      isLoading: false,
      notFound: false,
      filter: {
        email: "",
      },
      userInfo: null,
    };
  },

  computed: {
    userProfile() {
      return this.userInfo?.photo || "/images/default-user.png";
    },
    occupation() {
      return this.userInfo?.occupation;
    },
    profileName() {
      const {first_name, first_name_kh, last_name, last_name_kh} =
      this.userInfo || {};
      if (!this.$isKm()) return [first_name, last_name].join(" ");
      return [first_name_kh || first_name, last_name_kh || last_name].join(" ");
    },
    profileEmail() {
      return this.userInfo.email;
    },
    able2invited() {
      return !this.userInfo?.invite_request_status;
    },
    approvedInvitation() {
      return this.userInfo?.invite_request_status == "approved";
    },
  },
  methods: {
    ...mapActions("eso", ["invitedMember"]),
    visibleChange(v = false) {
      if (!v) {
        this.filter.email = "";
        this.userInfo = null;
        this.notFound = false;
      }
      this.$emit("update:visible", v);
    },
    submitSearch() {

      this.notFound = false;
      this.isLoading = true;
      const params = {email: this.filter.email, stakeholder_id: this.stakeholderId};
      this.$axios
          .$get("/api/v1/eso/invite-team/", {params})
          .then((res) => {
            this.userInfo = Object.assign({}, res);
            this.isLoading = false;
          })
          .catch((e) => {
            this.userInfo = null;
            this.isLoading = false;
            this.notFound = true;
          });
    },
    makeInvitation() {
      this.requestingInvitation = true;
      const payload = {
        to_user: this.userInfo.id,
        stakeholder_id: this.stakeholderId,
      };
      this.invitedMember(payload)
          .then((res) => {
            this.requestingInvitation = false;

            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
            Toast.fire("", this.$t("get_listed.dialog.title.success"), "success");
            this.$emit('fetch-profile');
            this.submitSearch();
          })
          .catch((error) => {
            this.requestingInvitation = false;
            const message = error.response.data.message || error;
            this.$swal.fire(
                `${this.$t("get_listed.dialog.title.fail")}!`,
                message,
                "error"
            );
          });
    },
  },
};
